import { createSlice } from '@reduxjs/toolkit';
import { IAction } from "../actionTypes";
import { TListingTableRow, ICurrency } from "@protoplan/types";

export interface ListingsState
{
  listings: TListingTableRow[] | undefined,
  vendors: Vendor[],
  currencies: ICurrency[],
  productId?: number
};

export interface Vendor
{
  vendorId: number;
  name: string;
  countryId: number;
  scrapeTime: Date;
  url?: string;
}

export const listingsSlice = createSlice({
  name: 'listings',
  initialState:
  {
    listings: undefined,
    vendors: <Vendor[]>[],
    currencies: <ICurrency[]>[],
    productId: undefined
  } as ListingsState,
  reducers: {
    updateListings: (state: ListingsState, action: IAction<TListingTableRow[] | undefined>) =>
    {
      state.listings = action.payload;
    },
    removeListing: (state: ListingsState, action: IAction<number>) =>
    {
      state.listings = state.listings?.filter(listing => listing.listingId !== action.payload);
    },
    updateVendors: (state: ListingsState, action: IAction<Vendor[]>) =>
    {
      state.vendors = action.payload;
    },
    updateCurrencies: (state: ListingsState, action: IAction<ICurrency[]>) =>
    {
      state.currencies = action.payload;
    },
    updateProductId: (state: ListingsState, action: IAction<number | undefined>) =>
    {
      state.productId = action.payload;
    },
    toggleDiscounts: (state: ListingsState, action: IAction<{
      listingId: number,
      discountIds: number[],
      discountedPrice: number,
      priceWithoutFees: number,
      priceWithFees: number }>) =>
    {
      const listing = state.listings?.find(l => l.listingId === action.payload.listingId);
      if(!listing)
        return;

      listing.discounts?.forEach(d =>
      {
        if(!action.payload.discountIds.includes(d.discountId))
          return;

        d.applied = !d.applied;
      });

      listing.priceWithoutFees = action.payload.priceWithoutFees;
      listing.priceWithFees = action.payload.priceWithFees;
      listing.discountedPrice = action.payload.discountedPrice;
    }
  }
});

export const {
  updateListings,
  removeListing,
  updateVendors,
  updateCurrencies,
  updateProductId,
  toggleDiscounts } = listingsSlice.actions;

export default listingsSlice.reducer;
